import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { ASSIGN_LABELS } from '../_constants/assignConstants'
import { useCloneForm } from '../_form/CloneServiceOrderForm'
import FormItem from '../../../../components/form/FormItem'
import GroupSelect from './GroupSelect'
import UserSelect from './UserSelect'

const AssignContent = () => {
  const form = useCloneForm()
  const canSeeOnlySelfSOs = useSessionPermission('seeOnlySelfServiceOrders')
  if (canSeeOnlySelfSOs) return false

  const label = ASSIGN_LABELS[form.assign]

  return (
    <FormItem label={label}>
      <UserSelect />
      <GroupSelect />
    </FormItem>
  )
}

export default AssignContent
